import { Breadcrumb as e } from "./@/index.js";
import { breadcrumbItemStyles as t, breadcrumbLinkStyles as n, breadcrumbRootStyles as r } from "./styles.js";
import { Tooltip as i } from "../tooltip/Tooltip.js";
import { cn as a } from "../cn.js";
import o, { useLayoutEffect as s, useRef as c, useState as l } from "react";
import { jsx as u } from "react/jsx-runtime";
// src/design/breadcrumbs/index.tsx
var d = () => null;
d.Root = ({ children: t, className: n, ...i }) => /* @__PURE__ */ u(e.Root, {
	className: a(r(), n),
	...i,
	children: t
}), d.Item = ({ children: n, className: r, ...i }) => /* @__PURE__ */ u(e.Item, {
	className: a(t(), r),
	...i,
	children: n
}), d.Link = e.Link;
var f = ({ children: e, content: t, isActive: n = !0 }) => {
	let [r, a] = l(!1), d = c(null);
	s(() => {
		let e = d.current;
		if (!e) return;
		let t = () => {
			a(e.scrollWidth > e.clientWidth);
		};
		t();
		let n = new ResizeObserver(t);
		return n.observe(e), () => n.disconnect();
	}, [t]);
	let f = o.cloneElement(e, { ref: (t) => {
		let { ref: n } = e || {};
		typeof n == "function" ? n(t) : n && (n.current = t), d.current = t;
	} });
	return n ? /* @__PURE__ */ u(i, {
		content: t,
		placement: "top",
		disabled: !r,
		size: "sm",
		children: f
	}) : f;
};
d.Default = ({ items: e, as: t }) => /* @__PURE__ */ u(d.Root, { children: e.map((r, i) => {
	let a = i === e.length - 1;
	return /* @__PURE__ */ u(d.Item, {
		isLast: a,
		children: /* @__PURE__ */ u(f, {
			isActive: !a,
			content: r.label,
			children: /* @__PURE__ */ u(d.Link, {
				as: t,
				"aria-label": r.label,
				to: r.to,
				href: r.href,
				isLast: a,
				className: n({ isLast: a }),
				"aria-current": a ? "page" : void 0,
				children: r.label
			})
		})
	}, r.label);
}) });
export { d as Breadcrumb };

//# sourceMappingURL=index.js.map